import styled from 'styled-components';


const Avatar = styled.div`
    width: 40px;
    height: 40px;
    background: no-repeat center/cover url(${p => p.src});
    border-radius: 4px;
    margin-right: 0.65rem;
`;

export default Avatar;
